<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title class="text-uppercase">Thông tin học sinh</v-toolbar-title>
        <v-spacer />
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pb-6 pt-0">
        <v-form>
          <div class="px-0 pt-6">
            <div class="d-flex">
              <div class="pb-6 d-flex" style="flex-grow: 1">
                <v-text-field
                  label="Tên học sinh"
                  v-model="studentName"
                  outlined
                  hide-details
                  style="flex-grow: 1"
                  class="pr-6"
                />
                <v-text-field
                  label="Trường"
                  v-model="studentSchool"
                  outlined
                  hide-details
                  style="flex-grow: 1"
                  class="pr-6"
                />
              </div>
            </div>

            <div class="d-flex">
              <div class="pb-6 d-flex" style="flex-grow: 1">
                <v-text-field
                  label="Ngày sinh (dd/mm/yyyy)"
                  v-model="studentDob"
                  mask="##/##/####"
                  return-masked-value
                  outlined
                  hide-details
                  style="flex-grow: 1"
                  class="pr-6"
                />
              </div>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-divider> </v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer />
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: { ...mapGetters({ user: 'auth/user', profile: 'lead/item' }) },
  data: () => ({ dialog: false, loading: false, studentName: '', studentSchool: '', studentDob: '' }),
  watch: {
    profile: {
      handler(val) {
        if (val) {
          this.studentName = val.studentName
          this.studentDob = val.studentDob
          this.studentSchool = val.studentSchool
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('lead', ['updateLead']),
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async submit() {
      try {
        this.$loading.active = true
        await this.updateLead({
          id: this.profile.id,
          studentName: this.studentName,
          studentDob: this.studentDob,
          studentSchool: this.studentSchool,
        })
        this.$alert.success('Cập nhật "Thông tin học sinh" thành công')
        this.$emit('refresh')
        this.close()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
